import { CoreMenu } from 'src/@core/types';

export const recruitmentMenu: CoreMenu[] = [
  {
    id: 'recruitment',
    title: 'Recruitment',
    type: 'collapsible',
    icon: 'recruitment.svg',
    role: {
      roles: ['employee'],
      right: 'F1111',
    },
    children: [
      {
        id: 'job-requisition',
        title: 'Job Requisition',
        type: 'item',
        icon: 'job-requisition.svg',
        url: '/hr360/recruitment/job-requisition',
        role: {
          roles: ['employee'],
          right: 'F2282',
        },
        exactMatch: true,
      },
      {
        id: 'req-approvals',
        title: 'Job Requisition Approvals',
        type: 'item',
        icon: 'recruitment-approvals.svg',
        url: '/hr360/recruitment/job-requisition/approvals',
        role: {
          roles: ['employee'],
          right: 'F2284',
        },
      },
      {
        id: 'job-request',
        title: 'Job Request',
        type: 'item',
        icon: 'job-request.svg',
        url: '/hr360/recruitment/job-request',
        role: {
          roles: ['employee'],
          right: 'F1129',
        },
      },
      {
        id: 'candidate-application',
        title: 'Candidate Application',
        type: 'item',
        icon: 'recruitment-candidate-application.svg',
        url: '/hr360/recruitment/candidate-application',
        role: {
          roles: ['employee'],
          right: 'F1114',
        },
      },
      {
        id: 'hierarchies',
        title: 'Hierarchies',
        type: 'item',
        icon: 'recruitment-hierarchies.svg',
        url: '/hr360/recruitment/hierarchies',
        role: {
          roles: ['employee'],
          right: 'F1124',
        },
      },
      {
        id: 'interview-forms',
        title: 'Interview Forms',
        type: 'item',
        icon: 'Online-Interview.svg',
        url: '/hr360/recruitment/interview-forms',
        role: {
          roles: ['employee'],
          right: 'F1152',
        },
      },
      {
        id: 'approvals',
        title: 'Approvals',
        type: 'item',
        icon: 'recruitment-approvals.svg',
        url: '/hr360/recruitment/approvals',
        role: {
          roles: ['employee'],
          right: 'F1112',
        },
      },
      {
        id: 'letter-templates',
        title: 'Letter Templates',
        type: 'item',
        icon: 'recruitment-letter-templates.svg',
        url: '/hr360/recruitment/letter-templates',
        role: {
          roles: ['employee'],
          right: 'F1142',
        },
      },
      {
        id: 'email-setting',
        title: 'Email Settings',
        type: 'item',
        icon: 'recruitment-letter-templates.svg',
        url: '/hr360/recruitment/email-setting',
        role: {
          roles: ['employee'],
          right: 'F1157',
        },
      },
    ],
  },
];
